export const changeLocation = (location, action) => ({
  type: 'router_changeLocation',
  location,
  action
})
